import { useDashboardColor } from "../../context/DashboardColorContext";
import { DisaggregatedMetric } from "../../services/types";
import { formatValue } from "../../utils/helpers";

function MetricStatValue({
    metric
}: {
    metric: DisaggregatedMetric | undefined;
}) {
    const color = useDashboardColor();

    // Destructure metric properties
    const id = metric?.id;
    const unit = metric?.versions[0].unit;
    const version = metric?.versions?.[0];
    const value = version?.value;
    const name = metric?.name

    return (
        <div className="space-y-0.5 flex flex-col items-center">
            <span className="text-3xl font-semibold leading-none" style={{ color }}>
                {value && unit && id ? formatValue(value, unit, id) : "N/A"}
            </span>
            <h3 className="text-xs font-semibold text-color-cai-brown text-center">
                {name}
            </h3>
        </div>
    );
}

export default MetricStatValue